/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 *
 * @export
 * @interface AuxiliaryRiskMetricResult
 */
export interface AuxiliaryRiskMetricResult {
  /**
   *
   * @type {number}
   * @memberof AuxiliaryRiskMetricResult
   */
  readonly id: number;
  /**
   *
   * @type {number}
   * @memberof AuxiliaryRiskMetricResult
   */
  source: number;
  /**
   *
   * @type {number}
   * @memberof AuxiliaryRiskMetricResult
   */
  metric: number;
  /**
   *
   * @type {string}
   * @memberof AuxiliaryRiskMetricResult
   */
  name: string;
  /**
   *
   * @type {any}
   * @memberof AuxiliaryRiskMetricResult
   */
  value: any | null;
  /**
   *
   * @type {Date}
   * @memberof AuxiliaryRiskMetricResult
   */
  timestamp?: Date;
}

/**
 * Check if a given object implements the AuxiliaryRiskMetricResult interface.
 */
export function instanceOfAuxiliaryRiskMetricResult(value: object): value is AuxiliaryRiskMetricResult {
  if (!('id' in value) || value['id'] === undefined) return false;
  if (!('source' in value) || value['source'] === undefined) return false;
  if (!('metric' in value) || value['metric'] === undefined) return false;
  if (!('name' in value) || value['name'] === undefined) return false;
  if (!('value' in value) || value['value'] === undefined) return false;
  return true;
}

export function AuxiliaryRiskMetricResultFromJSON(json: any): AuxiliaryRiskMetricResult {
  return AuxiliaryRiskMetricResultFromJSONTyped(json, false);
}

export function AuxiliaryRiskMetricResultFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): AuxiliaryRiskMetricResult {
  if (json == null) {
    return json;
  }
  return {
    id: json['id'],
    source: json['source'],
    metric: json['metric'],
    name: json['name'],
    value: json['value'],
    timestamp: json['timestamp'] == null ? undefined : new Date(json['timestamp']),
  };
}

export function AuxiliaryRiskMetricResultToJSON(value?: Omit<AuxiliaryRiskMetricResult, 'id'> | null): any {
  if (value == null) {
    return value;
  }
  return {
    source: value['source'],
    metric: value['metric'],
    name: value['name'],
    value: value['value'],
    timestamp: value['timestamp'] == null ? undefined : value['timestamp'].toISOString(),
  };
}
